import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b38b2b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, "箱贴", -1))
const _hoisted_3 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_4 = { style: {"height":"100% !important"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "link" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"30px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"70%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_miezz_form, {
            ref: "refForm",
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form) = $event)),
            fix: true,
            class: "form"
          }, {
            "form-item": _withCtx(({ item }) => [
              (item.Prop == 'CodeSource')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail != true)
                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                            key: 0,
                            modelValue: _ctx.form.Data.CodeSource,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.CodeSource) = $event)),
                            onHandleChange: _ctx.onChangeCodeSource,
                            options: _ctx.EnumPoolCodeSourceOption
                          }, null, 8, ["modelValue", "onHandleChange", "options"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.form.Data.CodeSourceName), 1))
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'BoxStickerCode')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    prop: _ctx.form.Data.CodeSource == 10?item.Prop:'',
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.form.Data.BoxStickerCode), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_ctx.form.Data.CodeSource == 10)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_miezz_input, {
                                    trim: true,
                                    modelValue: _ctx.form.Data.BoxStickerCode,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.BoxStickerCode) = $event)),
                                    placeholder: '请填写'
                                  }, null, 8, ["modelValue"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.form.Data.BoxStickerCode), 1))
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'PlaceofDelivery')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail != true)
                        ? (_openBlock(), _createBlock(_component_miezz_input, {
                            key: 0,
                            ref: "ref-delivery-place",
                            modelValue: _ctx.form.Data.PlaceofDelivery,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.PlaceofDelivery) = $event)),
                            trim: false,
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            onHandleChange: _ctx.onBlurPlaceofDelivery,
                            valueKey: "FullName",
                            onHandleSelect: _ctx.handleSelectDeliveryPlace
                          }, null, 8, ["modelValue", "fetch-suggestions", "onHandleChange", "onHandleSelect"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.form.Data.PlaceofDelivery), 1))
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'SumQuantity')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.Data.SumQuantity) + _toDisplayString(_ctx.form.Data.ChargeUnit), 1)
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'ProductionCountryName')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 4,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail != true)
                        ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                            key: 0,
                            modelValue: _ctx.form.Data.ProductionCountryName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.ProductionCountryName) = $event)),
                            clearable: "",
                            onBlur: _ctx.onBlurProductionCountryName,
                            "fetch-suggestions": _ctx.querySearchProductionCountryIdAsync,
                            "popper-class": "my-autocomplete",
                            placeholder: "请填写关键词",
                            onSelect: _ctx.handleSelectProductionCountryId,
                            onChange: _ctx.onChangeProductionCountryId,
                            onClear: _ctx.onChangeProductionCountryId
                          }, {
                            default: _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(item.Label), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onBlur", "fetch-suggestions", "onSelect", "onChange", "onClear"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.form.Data.ProductionCountryName), 1))
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _hoisted_13,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.bottomButtons,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClick
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}